import { QueryParamOptions, UtmParameters } from '@griply/types';
import { Paths } from 'shared/routes/paths';

export { QueryParamOptions };

// Carried through every redirect, the google and apple sign-in state and the app-domain hop.
// A sign-in credential (idToken, googleIdToken, desktopCode) or a mobile callback param never belongs here.
export const globalQueryParamOptions: (QueryParamOptions | UtmParameters)[] = [
  QueryParamOptions.ClaimToken,
  QueryParamOptions.OobCode,
  QueryParamOptions.Premium,
  QueryParamOptions.OnboardingPremium,
  QueryParamOptions.OnboardingDesktop,
  QueryParamOptions.Purchase,
  QueryParamOptions.PriceType,
  QueryParamOptions.ConnectionToken,
  QueryParamOptions.Search,
  QueryParamOptions.C,
  QueryParamOptions.ExternalId,
  QueryParamOptions.DesktopChallenge,
  QueryParamOptions.ExternalAuthId,
  QueryParamOptions.Featurebase,
  QueryParamOptions.ReturnTo,
  QueryParamOptions.EmailChangeToken,
  QueryParamOptions.Settings,
  ...Object.values(UtmParameters),
];

const baseAllowedQueryParamOptions = [
  ...Object.values(UtmParameters),
  QueryParamOptions.ClaimToken,
  QueryParamOptions.OobCode,
  QueryParamOptions.C,
  QueryParamOptions.Premium,
];

export const pathAllowedQueryParamOptions: Record<
  Paths,
  (QueryParamOptions | UtmParameters)[]
> = {
  [Paths.Home]: baseAllowedQueryParamOptions,
  [Paths.Inbox]: baseAllowedQueryParamOptions,
  [Paths.Upcoming]: baseAllowedQueryParamOptions,
  [Paths.AllTasks]: baseAllowedQueryParamOptions,
  [Paths.TaskCreate]: baseAllowedQueryParamOptions,
  [Paths.OpenInApp]: baseAllowedQueryParamOptions,
  [Paths.Completed]: baseAllowedQueryParamOptions,
  [Paths.Timeline]: baseAllowedQueryParamOptions,
  [Paths.Goals]: baseAllowedQueryParamOptions,
  [Paths.GoalsRoadmap]: baseAllowedQueryParamOptions,
  [Paths.GoalsCompleted]: baseAllowedQueryParamOptions,
  [Paths.GoalsArchived]: baseAllowedQueryParamOptions,
  [Paths.GoalsThisYear]: baseAllowedQueryParamOptions,
  [Paths.GoalsNextYear]: baseAllowedQueryParamOptions,
  [Paths.GoalsUnplanned]: baseAllowedQueryParamOptions,
  [Paths.GoalDetail]: baseAllowedQueryParamOptions,
  [Paths.GoalDetailRoadmap]: baseAllowedQueryParamOptions,
  [Paths.GoalDetailProgress]: baseAllowedQueryParamOptions,
  [Paths.GoalDetailTasks]: baseAllowedQueryParamOptions,
  [Paths.GoalTemplates]: [
    ...baseAllowedQueryParamOptions,
    QueryParamOptions.Search,
  ],
  [Paths.GoalsCalendar]: baseAllowedQueryParamOptions,
  [Paths.Projects]: baseAllowedQueryParamOptions,
  [Paths.ProjectDetail]: baseAllowedQueryParamOptions,
  [Paths.ProjectDetailRoadmap]: baseAllowedQueryParamOptions,
  [Paths.ProjectDetailProgress]: baseAllowedQueryParamOptions,
  [Paths.ProjectDetailTasks]: baseAllowedQueryParamOptions,
  [Paths.LifeAreas]: baseAllowedQueryParamOptions,
  [Paths.LifeAreaDetail]: baseAllowedQueryParamOptions,
  [Paths.LifeAreaDetailVision]: baseAllowedQueryParamOptions,
  [Paths.LifeAreaDetailRoadmap]: baseAllowedQueryParamOptions,
  [Paths.LifeAreaDetailTasks]: baseAllowedQueryParamOptions,
  [Paths.Habits]: baseAllowedQueryParamOptions,
  [Paths.HabitsCompleted]: baseAllowedQueryParamOptions,
  [Paths.Login]: [
    ...baseAllowedQueryParamOptions,
    QueryParamOptions.DesktopChallenge,
    QueryParamOptions.ExternalAuthId,
  ],
  [Paths.Signup]: [
    ...baseAllowedQueryParamOptions,
    QueryParamOptions.DesktopChallenge,
    QueryParamOptions.ExternalAuthId,
  ],
  [Paths.ForgotPassword]: baseAllowedQueryParamOptions,
  [Paths.ResetPassword]: baseAllowedQueryParamOptions,
  [Paths.CompleteSignup]: baseAllowedQueryParamOptions,
  [Paths.VerifyEmail]: baseAllowedQueryParamOptions,
  [Paths.ConfirmEmailChange]: [
    ...baseAllowedQueryParamOptions,
    QueryParamOptions.EmailChangeToken,
  ],
  [Paths.RevertEmailChange]: [
    ...baseAllowedQueryParamOptions,
    QueryParamOptions.EmailChangeToken,
  ],
  [Paths.Insights]: baseAllowedQueryParamOptions,
  [Paths.TagDetail]: baseAllowedQueryParamOptions,
  [Paths.SmartListDetail]: baseAllowedQueryParamOptions,
  [Paths.Search]: [...baseAllowedQueryParamOptions, QueryParamOptions.Search],
  [Paths.Trash]: baseAllowedQueryParamOptions,
  [Paths.DesktopConnected]: [
    ...baseAllowedQueryParamOptions,
    QueryParamOptions.DesktopChallenge,
  ],
  [Paths.McpConnect]: [
    ...baseAllowedQueryParamOptions,
    QueryParamOptions.ExternalAuthId,
  ],
};
